import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import {
  IconBattery1Duotone,
  IconBattery2Duotone,
  IconBattery3Duotone,
  IconBatteryFullDuotone,
} from '@roku-web-ui/rds-icons';

import styles from './batteryIndicator.module.scss';

interface BatteryIndicatorProps {
  batteryLevel: number;
}

const renderBatteryIcon = (batteryLevel: number) => {
  if (batteryLevel > 75) return <IconBatteryFullDuotone sx={{ fontSize: '3rem' }} />;
  if (batteryLevel > 50) return <IconBattery3Duotone sx={{ fontSize: '3rem' }} />;
  if (batteryLevel > 25) return <IconBattery2Duotone sx={{ fontSize: '3rem' }} />;
  if (batteryLevel >= 0) return <IconBattery1Duotone sx={{ fontSize: '3rem' }} />;
};

export const BatteryIndicator = ({ batteryLevel }: BatteryIndicatorProps) => (
  <Stack className={styles.batteryIndicator} data-testid="component-indicator-battery" direction="row">
    <Box className={styles.batteryIcon}>{renderBatteryIcon(batteryLevel)}</Box>
    <Typography className={styles.batteryText}>{batteryLevel} %</Typography>
  </Stack>
);
